import styled from 'styled-components'
import { ContainerOuterDiv, ContainerInnerDiv } from './MaxWidthLayout'

const LayoutContainerOuterDiv = styled(ContainerOuterDiv)`
  min-height: 100vh;
`

const GridPieceRight = styled.img`
  position: absolute;
  right: -55px;
  top: 25vh;
  width: 198px;
  height: 1110px;
  z-index: 0;
`

const GridPieceTopLeft = styled.img`
  position: absolute;
  left: 12.5%;
  width: 542.5px;
  height: 471.5px;

  top: -100px;
  z-index: 0;
`

function DefaultLayout({ children }: { children: React.ReactNode }) {
  return (
    <LayoutContainerOuterDiv>
      <ContainerInnerDiv>{children}</ContainerInnerDiv>
      {/* <GridPieceTopLeft src="/images/layout/bg_grid_2.png" />
      <GridPieceRight src="/images/layout/bg_grid_1.png" /> */}
    </LayoutContainerOuterDiv>
  )
}

export default DefaultLayout
